<div class="swipe-menu-header" (click)="onHeaderButtonClick()" (touchstart)="handleTouchStart($event)" (touchmove)="handleTouchMove($event)" (touchend)="handleTouchEnd($event)">
<div class="swipe-menu-header-button"></div>
</div>

<div class="swipe-menu-content" [class.closed]="!isOpened" (touchstart)="$event.stopPropagation()" (touchmove)="$event.stopPropagation()" (touchend)="$event.stopPropagation()">
  <ng-content></ng-content>
</div>
